module.exports.getLocales = () => {
  try {
    // eslint-disable-next-line global-require
    const locales = require('./locales.json');
    return locales;
  } catch (error) {
    return ['en'];
  }
};
